module.exports = __webpack_public_path__ + "static/img/SA-ava-nu.b57e195.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/SA-ava-nu.png
// module id = l8LK
// module chunks = 4